import { supabase } from "@/integrations/supabase/client";
import type { OsAccessLevel } from "./os-permissions";

/** Call the SQL resolver. Returns `'none'` on any error to fail closed. */
export async function resolveOsPermissionRemote(osId: string, userId: string): Promise<OsAccessLevel> {
  const { data, error } = await supabase.rpc("resolve_os_permission" as never, {
    _user_id: userId,
    _os_id: osId,
  } as never);
  if (error || typeof data !== "string") return "none";
  const v = data as OsAccessLevel;
  return v === "manager" || v === "editor" || v === "reader" ? v : "none";
}
